import React, { useContext } from "react";
import { AppContext } from "../../AppDataProvider/AppDataProvider";
import { margin } from "../../common/styles";
import styled from "styled-components";
import { Toast } from "./Toast/Toast";
export function ToastArea() {
  const {
    toast
  } = useContext(AppContext).appData;
  return <Container data-sentry-element="Container" data-sentry-component="ToastArea" data-sentry-source-file="ToastArea.tsx">
      {toast.map(({
      id,
      message,
      variant
    }) => <Toast key={id} toastId={id} variant={variant}>
          {message}
        </Toast>)}
    </Container>;
}
const Container = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  ${margin.l}
  z-index: 1;

  display: flex;
  flex-direction: column-reverse;
  gap: 0.5rem;
`;
export default ToastArea;